import React from 'react';
const BellIcon = ({ size=20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22a2 2 0 0 0 2-2H10a2 2 0 0 0 2 2z" />
    <path d="M18 16v-5a6 6 0 0 0-12 0v5l-2 2h16l-2-2z" />
  </svg>
);
export default BellIcon;